import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import type CalendarDay from 'modules/attendance/store/models/CalendarDay'

interface Props {
  date: moment.Moment
  calendarDay: CalendarDay
}

const DayColumn = ({ date }: Props) => {
  const weekDay = date.format('dddd')
  const monthDay = date.format('D MMM')

  return (
    <Box flexDirection="row" gap="s24">
      <Box>
        <Text.Normal weight="medium" color="grey1000" size="300">
          {monthDay}
        </Text.Normal>
        <Text.Normal size="100" color="grey800">
          {weekDay}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(DayColumn)
